import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { Alert } from "react-bootstrap";

import "./style.css";

class LWOCrypt4 extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} variant="light">
                <div onClick={this.props.blockLWOCrypt4IsOpen ? this.props.closeBlockLWOCrypt4 : this.props.openBlockLWOCrypt4}
                    style={{ display: "flex", borderBottom: this.props.blockLWOCrypt4IsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockLWOCrypt4IsOpen ? "50px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "80%" }}>
                        <div style={{ color: "black" }}> Документация LWOCrypt4 </div>
                    </div>
                    <div style={{ width: "20%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockLWOCrypt4IsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockLWOCrypt4IsOpen ?
                        <div style={{ paddingTop: '5px' }}>
                            <div className="doc_lwocrypt4" >
                                <Nav.Link href="/docs/java" style={{ margin: 0 }}>
                                    Java
                                </Nav.Link>
                            </div>
                            <div style={{ width: "100%", backgroundColor: "#e3e3e3", height: "1px", margin: '5px 0 5px 0' }} />
                            <div className="doc_lwocrypt4" >
                                <Nav.Link href="/docs/swift">
                                    Swift
                                </Nav.Link>
                            </div>

                        </div> : null
                }
            </Alert>
        );
    }
}

export default LWOCrypt4;
